export function generateVisitorId() {
  return Date.now().toString() + Math.floor(Math.random() * 1000000)
}

export function setVisitorIdCookie(visitorId, days = 365) {
  const expires = new Date()
  expires.setDate(expires.getDate() + days)
  const cookieString = `visitor_id=${visitorId}; expires=${expires.toUTCString()}; path=/`
  document.cookie = cookieString
}

export function getVisitorIdCookie() {
  const cookies = document.cookie.split('; ')
  let visitorId = null

  for (const cookie of cookies) {
    const [key, value] = cookie.split('=')
    if (key === 'visitor_id') {
      visitorId = value
      break
    }
  }

  if (visitorId) {
    setVisitorIdCookie(visitorId, 365)
  } else {
    visitorId = generateVisitorId()
    setVisitorIdCookie(visitorId, 365)
  }

  return visitorId
}
